// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface Props {
    label: string;
    value?: string | React.ReactNode;
}

interface OrderConfirmationInfoItemStyles {
    container?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
}

const orderConfirmationInfoItemStyles: OrderConfirmationInfoItemStyles = {
    container: {
        css: css`
            display: flex;
            gap: 8px;
        `,
    },
    labelText: {
        size: fontConfig.singleLineSmall.size,
        lineHeight: fontConfig.singleLineSmall.lineHeight,
        weight: fontConfig.weight.medium,
        css: css`
            white-space: nowrap;
        `,
    },
    valueText: {
        size: fontConfig.singleLineSmall.size,
        lineHeight: fontConfig.singleLineSmall.lineHeight,
        weight: fontConfig.weight.regular,
    },
};

const styles = orderConfirmationInfoItemStyles;
const OrderConfirmationInfoItem = ({ label, value }: Props) => {
    if (!value) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector={`OrderConfirmationInfoItem_${label}`}>
            <Typography {...styles.labelText}>{label}:</Typography>
            <Typography {...styles.valueText}>{value}</Typography>
        </StyledWrapper>
    );
};

export default OrderConfirmationInfoItem;
